export function checkScreenSize(winWidth) {
  const isXs = winWidth < 768;;
  const isSm = winWidth >= 768 && winWidth < 992;;
  const isMd = winWidth >= 992 && winWidth < 1200;;
  const isLg = winWidth >= 1200;

  let screenSize
  if (isLg) {
    screenSize = "lg";
  } else if (isMd) {
    screenSize = "md";
  } else if (isSm) {
    screenSize = "sm";
  } else if (isXs) {
    screenSize = "xs";
  };

  return screenSize
}



// WEBPACK FOOTER //
// ./src/utils.js